import { render, staticRenderFns } from "./BaseReservation.vue?vue&type=template&id=0a9f20ae&scoped=true&"
import script from "./BaseReservation.vue?vue&type=script&lang=js&"
export * from "./BaseReservation.vue?vue&type=script&lang=js&"
import style0 from "./BaseReservation.vue?vue&type=style&index=0&id=0a9f20ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f20ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
